import * as Yup from 'yup';

export const formSchema = [
  {
    name: 'phoneNumber',
    validate: Yup.string()
      .required('Vui lòng nhập số điện thoại người nhận')
      .matches(/^\d{10,11}$/, 'Số điện thoại phải gồm 10 hoặc 11 chữ số'),
  },
  {
    name: 'amount',
    validate: Yup.number()
      .typeError('Số điểm không hợp lệ')
      .moreThan(0, 'Số điểm phải lớn hơn 0')
      .required('Vui lòng nhập số điểm cần chuyển'),
  },
];
